module.exports = __webpack_public_path__ + "static/media/hen_searching_food.145572eb.gif";